import { render, staticRenderFns } from "./AverageYearBar.vue?vue&type=template&id=d5255800&"
import script from "./AverageYearBar.vue?vue&type=script&lang=js&"
export * from "./AverageYearBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports